<template>
  <el-dialog title="添加自定义主播ID" :visible.sync="visible" @close="cancelAnchorId" width="30%">
    <el-row style="margin-bottom: 12px">
      <el-input v-model="newAnchorId" placeholder="请输入主播ID（可用逗号分隔批量添加）" style="width: 260px; margin-right: 10px"></el-input>
      <el-button type="primary" @click="addNewAnchorId">添加</el-button>
    </el-row>
    <el-row style="margin-bottom: 20px">
      <el-input v-model="batchRemoveInput" placeholder="请输入要删除的主播ID（逗号分隔）" style="width: 260px; margin-right: 10px" clearable></el-input>
      <el-button type="danger" @click="batchRemoveIds">批量删除</el-button>
    </el-row>
    <el-input v-model="anchorIdSearch" placeholder="请输入主播ID搜索" style="margin-bottom: 20px" clearable></el-input>
    <el-table :data="filteredAnchorIdList" style="width: 100%" height="400px">
      <el-table-column prop="anchorId" label="主播ID">
        <template slot-scope="scope">
          {{ Math.abs(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="removeId(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px; text-align: right;">
      <el-button @click="cancelAnchorId">取消</el-button>
      <el-button type="primary" @click="confirmAnchorId">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AnchorIdManager',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    anchorIdList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      anchorIdSearch: '',
      newAnchorId: '',
      batchRemoveInput: '',
    }
  },
  computed: {
    filteredAnchorIdList() {
      if (!this.anchorIdSearch) {
        return this.anchorIdList;
      }
      return this.anchorIdList.filter(id =>
        id.toString().includes(this.anchorIdSearch)
      );
    }
  },
  methods: {
    addNewAnchorId() {
      if (!this.newAnchorId) {
        this.$message.warning('请输入主播ID');
        return;
      }

      const idsToAdd = this.newAnchorId.split(',').map(id => id.trim()).filter(id => id !== '');

      if (idsToAdd.length === 0) {
        return this.$message.warning('请输入有效的ID');
      }

      let addedCount = 0;
      let invalidCount = 0;
      let duplicateCount = 0;

      idsToAdd.forEach(id => {
        const numId = parseInt(id);
        if (isNaN(numId)) {
          invalidCount++;
          return;
        }

        // 检查是否已存在相同ID
        if (this.anchorIdList.some(existingId => parseInt(existingId) === numId)) {
          duplicateCount++;
          return;
        }

        this.$emit('addId', numId);
        addedCount++;
      });

      this.newAnchorId = ''; // 清空输入框

      let message = '';
      if (addedCount > 0) {
        message += `成功添加 ${addedCount} 个ID。`;
      }
      if (invalidCount > 0) {
        message += `${invalidCount} 个ID格式无效。`;
      }
      if (duplicateCount > 0) {
        message += `${duplicateCount} 个ID已存在。`;
      }
      if (message) {
        this.$message.success(message.trim());
      }
    },
    batchRemoveIds() {
      if (!this.batchRemoveInput) {
        return this.$message.warning('请输入要删除的ID');
      }

      const idsToRemove = this.batchRemoveInput
        .split(',')
        .map(id => id.trim())
        .filter(id => id !== '')
        .map(id => parseInt(id))
        .filter(id => !isNaN(id));

      if (idsToRemove.length === 0) {
        return this.$message.warning('请输入有效的ID');
      }

      const uniqueIds = [...new Set(idsToRemove)];
      
      // 检查哪些ID存在于列表中
      const existingIds = uniqueIds.filter(id => 
        this.anchorIdList.some(existingId => parseInt(existingId) === id)
      );
      const notFoundIds = uniqueIds.filter(id => 
        !this.anchorIdList.some(existingId => parseInt(existingId) === id)
      );

      // 只删除存在的ID
      if (existingIds.length > 0) {
        this.$emit('removeIds', existingIds);
      }

      this.batchRemoveInput = '';

      // 根据情况显示不同的提示
      let message = '';
      if (existingIds.length > 0) {
        message += `成功删除 ${existingIds.length} 个ID。`;
      }
      if (notFoundIds.length > 0) {
        message += `${notFoundIds.length} 个ID不存在于列表中。`;
      }
      
      if (message) {
        if (notFoundIds.length > 0 && existingIds.length === 0) {
          this.$message.warning(message.trim());
        } else {
          this.$message.success(message.trim());
        }
      }
    },
    removeId(index) {
      // 获取过滤后的列表中的实际索引
      const actualIndex = this.anchorIdList.indexOf(this.filteredAnchorIdList[index]);
      if (actualIndex > -1) {
        this.$emit('removeId', actualIndex);
      }
    },
    cancelAnchorId() {
      this.anchorIdSearch = '';
      this.newAnchorId = '';
      this.$emit('cancel');
    },
    confirmAnchorId() {
      // 先对列表进行去重，将所有值转换为数字类型
      const uniqueIds = [...new Set(this.anchorIdList.map(id => parseInt(id)))];
      // 根据列表长度决定保存格式
      const userGroup = uniqueIds.length > 0
        ? uniqueIds.length > 1
          ? uniqueIds.join(',')
          : uniqueIds[0] || ''
        : '';
      
      this.$emit('confirm', userGroup);
      this.anchorIdSearch = '';
      this.newAnchorId = '';
    }
  }
}
</script>

<style scoped lang="scss">
.el-dialog {
  .el-table {
    .el-button {
      margin: 0;
    }
  }
}
</style> 
